import {RaffleCategoryMetadata} from '@core/models/raffle.model';

export enum PathType {
  result = 'result',
  winner = 'winner',
  category = 'category',
  none = 'none',
}

export class PathTypeToken {
  pathType: PathType;
  slug: string;
  categoryData: RaffleCategoryMetadata;
}
